import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=450c2c8a&scoped=true&"
import script from "./journal.vue?vue&type=script&lang=js&"
export * from "./journal.vue?vue&type=script&lang=js&"
import style0 from "./journal.vue?vue&type=style&index=0&id=450c2c8a&lang=less&scoped=true&"
import style1 from "./journal.vue?vue&type=style&index=1&id=450c2c8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450c2c8a",
  null
  
)

export default component.exports